import { Component, h, Prop, Element } from '@stencil/core';

/**
 * COMPNAME is for creating a container for buttons and links supporting additional specific user interactions on a Journal Article page:
 * - A link to a PDF of the article (if it exists).
 * - Printing the current page
 * - A jump link to the comments section (if present on the page)
 */
@Component({
  tag: 'aafp-journal-article-supporting-links',
  shadow: false,
})
export class AafpJournalArticleSupportingLinks {
  /**
   * For a link to a PDF of the article. If omitted, the "PDF" link will not display.
   */
  @Prop() pdfLink: string;

  /**
   * For the id of the comments section on the page (jump link target). If omitted, the "Comments" link will not display.
   */
  @Prop() commentsJumpLinkTarget: string;

  @Element() element: HTMLElement;

  onPrintButtonClick() {
    window.print();
  }

  render() {
    return (
      <div class="adl-journal-article-supporting-links">
        {this.pdfLink && (
          <a class="adl-journal-article-supporting-links__link" href={this.pdfLink}>
            <i class="material-icons" aria-hidden="true">
              picture_as_pdf
            </i>
            PDF
          </a>
        )}
        <button class="adl-journal-article-supporting-links__link" onClick={() => this.onPrintButtonClick()}>
          <i class="material-icons" aria-hidden="true">
            print
          </i>
          Print
        </button>
        {this.commentsJumpLinkTarget && (
          <a class="adl-journal-article-supporting-links__link" href={this.commentsJumpLinkTarget}>
            <i class="material-icons" aria-hidden="true">
              comment
            </i>
            Comments
          </a>
        )}
      </div>
    );
  }
}
